const caseLang = {
  List: {
    Title: 'Cases',
    CaseCount: '#{count} total',
    DateRange: {
      Label: 'Date range',
      Options: {
        TODAY: 'Today',
        LAST_3_DAYS: 'Last 3 days',
        LAST_7_DAYS: 'Last 7 days',
        LAST_28_DAYS: 'Last 28 days',
      },
    },
    CaseTypeGroup: {
      Label: 'Team',
      Options: {
        ALL: 'All teams',
        SALES: 'Sales',
        RECRUITING: 'Recruiting',
        OPERATIONS: 'Operations',
      },
    },
    LoadMore: 'Load more',
    PendingOnly: 'Pending',
    LoadFailed: 'Could not load cases.',
    Loading: 'Loading cases...',
    PriorityLabel: 'P#{priority}',
    PriorityUnprioritized: 'Unprioritized',
    Empty: 'No cases match these filters.',
    NoCaseSelected: 'No case selected',
    StatusDisplay: {
      OPEN: 'Agent Processing...',
      PENDING: 'Waiting/Needs Attention',
    },
    Mark: {
      Label: 'Mark',
      Options: {
        ALL: 'Any mark',
        MARKED_GOOD: 'Passed',
        MARKED_BAD: 'Failed',
        FLAGGED: 'Flagged',
        UNREVIEWED: 'Unreviewed',
      },
    },
  },
  Communication: {
    Title: 'Communication',
    NoCaseSelected: 'No case selected',
    Participants: 'Participants',
    NoParticipants: 'No participants',
    Methods: 'Methods',
    EmptyMessages: 'No messages for this method.',
    EmptyMessageBody: 'No message body.',
    LoadFailed: 'Could not load messages for this participant.',
    LoadMore: 'Load more',
    UnsupportedParticipant: 'Communication is not available for this participant type yet.',
    ParticipantTypes: {
      CLIENT: 'Client',
      CLIENT_RELATIONSHIP: 'Client relationship',
      CAREGIVER: 'Caregiver',
      OTHER: 'Participant',
      Client: 'Client',
      Caregiver: 'Caregiver',
      Other: 'Participant',
    },
    MethodOptions: {
      All: 'All',
      Internal: 'Internal',
      Email: 'Email',
      Sms: 'SMS',
      Call: 'Call',
      Chat: 'Chat',
    },
    MessageTypes: {
      ANNOUNCEMENTS: 'Announcement',
      COMMENTS: 'Internal note',
      CALENDLY_UPDATE: 'Calendly update',
      DIALPAD_SMS_TEXT: 'SMS',
      DIALPAD_CALL_TRANSCRIPT: 'Call transcript',
      EMAIL: 'Email',
      UNKNOWN: 'Message',
    },
    Chat: {
      Attachment: 'Attachment',
      AttachmentCount: '#{count} attachment(s)',
      Empty: 'No chat conversations.',
      LoadFailed: 'Could not load chat conversations.',
      MessagesLoadFailed: 'Could not load chat messages.',
      NoMessages: 'No chat messages.',
      SupportChat: 'Support chat',
      Unavailable: 'Chat is only available for caregiver participants right now.',
      UnknownConversation: 'Conversation',
      UnknownSender: 'Unknown sender',
    },
    Compose: {
      ClientRecipientLabel: 'Recipient',
      EmailPlaceholder: 'Write an email...',
      InternalPlaceholder: 'Write an internal note...',
      InternalTypeLabel: 'Internal type',
      InternalTypes: {
        Announcements: 'Announcement',
        Comments: 'Comment',
      },
      NoClientRecipients: 'No client relationship recipients are available for this case participant.',
      SaveNote: 'Save note',
      SelectMethod: 'Choose Internal, Email, or SMS to write from this panel.',
      SendEmail: 'Send email',
      SendFailed: 'Could not send this message.',
      SendSms: 'Send SMS',
      SmsPlaceholder: 'Write an SMS...',
      SubjectPlaceholder: 'Subject',
      UnsupportedMethod: 'Sending is not available for this method yet.',
    },
  },
  Status: {
    OPEN: {
      Title: 'OPEN',
      ColumnTitle: 'Open',
    },
    PENDING: {
      Title: 'PENDING',
      ColumnTitle: 'Pending',
    },
    COMPLETE: {
      Title: 'COMPLETE',
      ColumnTitle: 'Complete',
    },
    DELETED: {
      Title: 'DELETED',
      ColumnTitle: 'Deleted',
    },
  },
  Detail: {
    EmptyValue: '-',
    NotFound: 'Case not found',
    Fields: {
      CaseId: 'Case ID',
      Participants: 'Participants',
      Status: 'Status',
      Priority: 'Priority',
      Created: 'Created',
      Updated: 'Updated',
    },
    DomainGuide: {
      Title: 'Domain Guide',
      Loading: 'Loading domain guide...',
      Unavailable: 'Domain guide unavailable.',
    },
    ActionLog: {
      Title: 'Action Log',
      Empty: 'No action log entries.',
      Placeholder: 'Add an action log entry...',
      AdminMessage: 'Inbound admin chat message: #{userRn}: #{actionLogMessage}',
    },
    AgentJobs: {
      DraftTitle: 'Agent Draft',
      HoldingForReview: 'Holding for review',
      UnknownRecipient: 'Unknown recipient',
      UnknownAction: 'Agent job',
      ToRecipient: 'To #{recipient}',
      TimerTitle: 'Reopen case',
      Due: 'due',
      EmptyPayload: 'No payload content.',
      InvalidExecuteAt: 'Execute at must be a valid date and time.',
      InvalidJson: '#{label} must be valid JSON.',
      WeeklyPay: '$#{amount} weekly pay',
      LoadFailed: 'Could not load agent jobs.',
      SaveFailed: 'Could not update this agent job.',
      DiscardFailed: 'Could not discard this agent job.',
      SendNowFailed: 'Could not send this agent job now.',
      Edit: 'Edit',
      Discard: 'Discard',
      SendNow: 'Send now',
      Save: 'Save',
      Cancel: 'Cancel',
      Fields: {
        To: 'To',
        Sender: 'Sender',
        Subject: 'Subject',
        Message: 'Message',
        Body: 'Body',
        Type: 'Type',
        Params: 'Params',
        Service: 'Service',
        Method: 'Method',
        Path: 'Path',
        RequestBody: 'Request body',
        Conversation: 'Conversation',
        Requester: 'Requester',
        Payload: 'Payload',
        ExecuteAt: 'Execute at',
      },
      ActionLabels: {
        CaregiverSupportChat: 'Caregiver support chat',
        Email: 'Email',
        InternalApiCall: 'Internal API call',
        PushNotification: 'Push notification',
        Sms: 'SMS',
        Timer: 'Timer',
      },
      List: {
        Title: 'Working Log',
        CompletedTitle: '#{action} completed',
        CancelledTitle: '#{action} cancelled',
        FailedTitle: '#{action} failed',
        ToRecipient: 'to #{recipient}',
        ChatMessage: 'chat message',
      },
    },
    Marks: {
      Title: 'Marks',
      Empty: 'No marks for this case yet.',
      LoadFailed: 'Could not load marks.',
      DisplayGrade: 'Display grade',
      DisplayGradeHint: 'The latest human review supersedes the teacher for the case\'s grade of record.',
      Teacher: 'Teacher',
      Human: 'Human review',
      ReviewedBy: 'by #{reviewerRn}',
      Confidence: '#{confidence}% confident',
      AutoFail: 'Auto-fail',
      Grades: {
        PASS: 'Pass',
        FAIL: 'Fail',
        UNCERTAIN: 'Uncertain',
        SKIPPED_INTERVENTION: 'Skipped — human intervened',
      },
      Checklist: {
        Show: 'Show checklist (#{count})',
        Hide: 'Hide checklist',
        PassingDefinition: 'Passing definition',
        Answers: {
          VIOLATED: 'Violated',
          CLEAN: 'Clean',
          INSUFFICIENT_EVIDENCE: 'Insufficient evidence',
          MET: 'Met',
          NOT_MET: 'Not met',
          TRIGGERED: 'Triggered',
          NOT_TRIGGERED: 'Not triggered',
        },
      },
    },
    Review: {
      Title: 'Review this case',
      Subtitle: 'Record your own grade — it overrules the teacher\'s grade for this case. Optional, never assigned.',
      Pass: 'Pass',
      Fail: 'Fail',
      CategoryLabel: 'Failure category',
      CategoryPlaceholder: 'Select a category',
      ReasoningPlaceholder: 'Why? (optional, but it helps calibrate the teacher)',
      ExcludeGoldenSet: 'Exclude from golden set',
      ExcludeGoldenSetHint: 'Golden-set reviews are re-checked automatically whenever this guide is edited.',
      ExcludeGoldenSetFlaggedNote: 'Ticked for you: the teacher flagged this case rather than grading it, so your verdict ' +
        'would become ground truth for a case it could not call — and every future re-check would likely flag it again. ' +
        'Your review still settles the flag and moves the score. Untick it if this case is a clear-cut example.',
      Submit: 'Submit review',
      Submitting: 'Submitting...',
      SubmitFailed: 'Could not submit this review.',
      Submitted: 'Review recorded.',
      NoGuide: 'No domain guide matches this case type, so it cannot be reviewed.',
      NoRubric: 'This guide has no rubric yet — add one on the guide page to enable failure categories.',
    },
  },
};

export default caseLang;
